<template>
  <Stack class="stk-p-8 stk-gap-6">
    <Box>
      <BoxHead>
        <Title>Open Case</Title>
      </BoxHead>
      <div class="cases-toolbar">
        <router-link :to="{ name: 'cases-home' }">Back to Cases</router-link>
      </div>
      <CaseSubmissionForm
        submit-url="/api/v1/cases/"
        :show-client-selector="true"
        @submitted="handleCaseFormSubmitted"
        @cancel="cancelNewCase"
        @dirty-state-changed="updateDirtyState"
      />
    </Box>
  </Stack>
</template>

<script>
import {
  Box,
  BoxHead,
  Stack,
  Title,
} from '@stakeui';
import CaseSubmissionForm from '@frontend/ui/features/example/components/CaseSubmissionForm.vue';

const UNSAVED_CHANGES_MESSAGE = 'Are you sure you want to move away from this page? You have unsaved changes.';

export default {
  name: 'CaseCreate',
  components: {
    Box,
    BoxHead,
    CaseSubmissionForm,
    Stack,
    Title,
  },
  beforeRouteLeave(to, from, next) {
    if (!this.shouldWarnAboutUnsavedChanges()) {
      next();
      return;
    }
    const shouldLeave = window.confirm(UNSAVED_CHANGES_MESSAGE);
    next(shouldLeave);
  },
  data() {
    return {
      hasUnsavedCaseChanges: false,
      isBypassingUnsavedChangesWarning: false,
    };
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    shouldWarnAboutUnsavedChanges() {
      return this.hasUnsavedCaseChanges && !this.isBypassingUnsavedChangesWarning;
    },
    handleBeforeUnload(event) {
      if (!this.shouldWarnAboutUnsavedChanges()) {
        return undefined;
      }
      event.preventDefault();
      event.returnValue = UNSAVED_CHANGES_MESSAGE;
      return UNSAVED_CHANGES_MESSAGE;
    },
    updateDirtyState(hasUnsavedChanges) {
      this.hasUnsavedCaseChanges = Boolean(hasUnsavedChanges);
      if (hasUnsavedChanges) {
        this.isBypassingUnsavedChangesWarning = false;
      }
    },
    cancelNewCase() {
      this.$router.push({ name: 'cases-home' });
    },
    handleCaseFormSubmitted(payload) {
      this.isBypassingUnsavedChangesWarning = true;
      const data = payload?.data || payload;
      const attachmentUploadFailed = Boolean(payload?.attachmentUploadFailed);
      const submittedCase = data?.case || data || null;
      const caseId = submittedCase?.id;
      const entityExternalId = submittedCase?.entity?.external_id || submittedCase?.entity_external_id || '';

      if (!caseId) {
        this.$router.push({ name: 'cases-home' });
        return;
      }

      if (entityExternalId) {
        this.$router.push({
          name: 'entity-cases',
          params: { entityExternalId: String(entityExternalId) },
          query: {
            caseId: String(caseId),
            ...(attachmentUploadFailed ? { attachmentUploadFailed: '1' } : {}),
          },
        });
        return;
      }

      this.$router.push({
        name: 'case-detail',
        params: { caseId: String(caseId) },
        query: {
          ...(attachmentUploadFailed ? { attachmentUploadFailed: '1' } : {}),
        },
      });
    },
  },
};
</script>

<style scoped>
.cases-toolbar {
  display: flex;
  gap: var(--stk-size-4);
  margin-bottom: var(--stk-size-4);
}
</style>
